import { Component, Input } from '@angular/core';

export type UserItem = {
  firstName: string;
  lastName: string;
  logoUrl: string;
  initials: string;
  email: string;
  _id: string;
};

@Component({
  selector: 'orgbrain-user-item',
  templateUrl: './user-item.component.html',
  standalone: false,
})
export class UserItemComponent {
  @Input() item: UserItem;
}
